/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximumattendees1Inputs */

const en_maximumattendees1 = /** @type {(inputs: Maximumattendees1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum attendees`)
};

const de_maximumattendees1 = /** @type {(inputs: Maximumattendees1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Teilnehmerzahl`)
};

/**
* | output |
* | --- |
* | "Maximum attendees" |
*
* @param {Maximumattendees1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maximumattendees1 = /** @type {((inputs?: Maximumattendees1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximumattendees1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maximumattendees1(inputs)
	return de_maximumattendees1(inputs)
});
export { maximumattendees1 as "maximumAttendees" }